import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import FieldContext from './FieldContext';

var FieldLabel = function FieldLabel(props) {
  var _classnames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var _useContext2 = useContext(FieldContext),
      contextLabelWidth = _useContext2.labelWidth,
      contextLabelAlign = _useContext2.labelAlign;

  var _getCompProps = getCompProps('Form', userDefaultProps, props),
      value = _getCompProps.value,
      width = _getCompProps.width,
      textAlign = _getCompProps.textAlign,
      customizePrefixCls = _getCompProps.prefixCls,
      requiredMark = _getCompProps.requiredMark;

  if (value === undefined) return null;
  var fieldLabelPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, 'form-field-label', customizePrefixCls);
  var mergedLabelWidth = width || contextLabelWidth;
  var mergedLabelAlign = textAlign || contextLabelAlign;
  var labelWrapperClassName = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(fieldLabelPrefixCls), true), _defineProperty(_classnames, "".concat(fieldLabelPrefixCls, "-right"), mergedLabelAlign === 'right'), _classnames));
  var labelClassName = classnames(_defineProperty({}, "".concat(fieldLabelPrefixCls, "-required-mark"), requiredMark));
  var style = {
    width: mergedLabelWidth
  };
  return /*#__PURE__*/React.createElement("div", {
    className: labelWrapperClassName,
    style: style
  }, /*#__PURE__*/React.createElement("label", {
    className: labelClassName,
    title: value
  }, value));
};

export default FieldLabel;